export const prefix = 'connection'

export const SOCKET_STATUS_CHANGED = `${prefix}/SOCKET_STATUS_CHANGED`

export enum SocketStatus {
  Connecting = 'connecting',
  Connected = 'connected',
  Reconnecting = 'reconnecting',
}

export const setSocketStatus = (status: SocketStatus) => ({
  type: SOCKET_STATUS_CHANGED,
  data: { status },
})
